import React from 'react';
import _get from 'lodash/get';
import { useRouter } from 'next/router';

/* user data */
import { useUser } from '../../services/profile';
/* feature flags */
import { useFeatures } from '../DynamicFeatureProvider';

const CheckPageAccess = ({ flag, userRole }) => {
  const { isFlagEnabled, isReady } = useFeatures();
  const { userIsReady, user } = useUser();
  const router = useRouter();

  React.useEffect(() => {
    if (!isReady) {
      return;
    }

    if (flag) {
      const isFlagForPageEnabled = isFlagEnabled(flag);

      if (!isFlagForPageEnabled) {
        router.push('/');
      }
    }

    if (userRole === 'linkplus') {
      if (!userIsReady) {
        return;
      }
      if (!_get(user, ['association', 'linkplus'], false)) {
        router.push('/');
      }
    }
  }, [isReady, isFlagEnabled, userRole, userIsReady, user, flag, router]);

  return null;
};

export default CheckPageAccess;
